import MessagePay from './MessagePay'
export default MessagePay
